import React, { useState, useEffect } from "react";

const AdminOpd=()=>{
    const mobNum=localStorage.getItem("moblie")

    var [tit, setTit] = useState("");
        var [firstName, setFirstName] = useState("");
        var [middleName, setMiddleName] = useState("");
        var [lastName, setLastName] = useState("");
        var [fatherName, setFatherName] = useState("");
        var [aadhaarNo, setAadhaarNo] = useState("");
        var [mobileNo, setMobileNo] = useState("");
        var [panNo, setPanNo] = useState("");
        var [email, setEmail] = useState("");
        var [gender, setGender] = useState("");
        var [dob, setDob] = useState("");

    return(

        <>


<div className="row justify-content-around ">
      
        <div className="col-4">
          <div className="form-outline mb-3">
            <label className="form-label" for="id">
              Name :
            </label>
            <input
              type="mobile"
              id="aadhaarcard"
              onChange={(e) => setFirstName(e.target.value)}
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div>
        
        
        <div className="col-4">
          <div className="form-outline mb-3 ">
            <label className="form-label" for="id">
              Email:
            </label>
            <input
              type="mobile"
              //   onChange={(e) => setEmail(e.target.value)}
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div>
        <div className="col-4">
          <div className="form-outline mb-3 ">
            <label className="form-label" for="id">
              Place Of Posting:
            </label>
            <input
              type="mobile"
              //   onChange={(e) => setEmail(e.target.value)}
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div>
        <div className="col-4">
          <div className="form-outline mb-3 ">
            <label className="form-label" for="id">
              User Type:
            </label>
            <input
              type="mobile"
              //   onChange={(e) => setEmail(e.target.value)}
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div>
        <div className="col-4">
          <div className="form-outline mb-3 ">
            <label className="form-label" for="id">
              User Id:
            </label>
            <input
              type="mobile"
              //   onChange={(e) => setEmail(e.target.value)}
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div>
       
        <div className="col-4">
          <div className="form-outline mb-3 ">
            <label className="form-label" for="id">
              Designation:
            </label>
            <input
              type="mobile"
              //   onChange={(e) => setEmail(e.target.value)}
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div>

        <div className="col-4">
          <div className="form-outline mb-3 ">
            <label className="form-label" for="id">
              Location:
            </label>
            <input
              type="mobile"
              //   onChange={(e) => setEmail(e.target.value)}
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div>
        <div className="col-4">
          <div className="form-outline mb-3 ">
            <label className="form-label" for="id">
              Status:
            </label>
            <input
              type="mobile"
              //   onChange={(e) => setEmail(e.target.value)}
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div>

        <div className="col-4">
          <div className="form-outline mb-3 ">
            <label className="form-label" for="id">
              Admin Name:
            </label>
            <input
              type="mobile"
              //   onChange={(e) => setEmail(e.target.value)}
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div>

        <div className="col-4">
          <div className="form-outline mb-3 ">
            <label className="form-label" for="id">
              Password:
            </label>
            <input
              type="mobile"
              //   onChange={(e) => setEmail(e.target.value)}
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div>

      </div>



      
        </>
    )
}
export default AdminOpd; 